import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconFileTiff.tsx
const IconFileTiff = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M2 2h11.5v4A1.5 1.5 0 0 0 15 7.5h4V8h-9a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h9v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#ece5e3",
			d: "M14.5 2.5V6a.5.5 0 0 0 .5.5h3.5z"
		}),
		/* @__PURE__ */ jsx("path", {
			fill: "#a473f5",
			fillRule: "evenodd",
			d: "M9 10a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-6m10.284.808v4.188h.912V13.28h1.59v-.804h-1.59v-.858h1.866v-.81zm-7.347 4.282v-3.378h1.134v-.81H9.89v.81h1.134v3.378zm1.595-.726v.726h1.992v-.726h-.54v-2.736h.54v-.726h-1.992v.726h.54v2.736zm2.487.726v-4.188h2.778v.81h-1.866v.858h1.59v.804h-1.59v1.716z",
			clipRule: "evenodd"
		})
	]
});
var IconFileTiff_default = forwardRef(IconFileTiff);
//#endregion
export { IconFileTiff_default as default };
